import {i18n} from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function PrimaryFuelChips() {
  const {catalogueApi} = useVehicleFormContext();

  return (
    <Field
      type="chips"
      name="fuelType"
      options={catalogueApi?.fuelTypeOptions ?? []}
      label={i18n.t('entity.vehicle.labels.fuel')}
      isDeselectable
    />
  );
}
